import Icon from 'veui/components/Icon'
import { IconHeartCancel } from 'dls-icons-vue'

Icon.register('heart-cancel', IconHeartCancel)
